import {
  parseTranslations,
  CommonTranslations,
  Logout,
  Sites,
  cookie,
  constants
} from '@pdrj/pmi-iqos-shared-react'
import LogoutTranslations from './logout.json'

Logout.componentTranslations = {
  ...LogoutTranslations,
  ...CommonTranslations
}

Logout.componentDefaultProps = {
  ...Logout.componentDefaultProps,
  translations: {
    ...parseTranslations(Logout.componentTranslations, true)
  },
  site: Sites.iqosphere
}

Logout.onLogoutSuccessAdditionalAction = async () => {
  const spiceId = cookie.getSpiceId()
  cookie.remove(`${constants.COOKIE_SKIPPED_AVATAR}_${spiceId}`)
}

export default Logout
